import { render, staticRenderFns } from "./FaqSearchPager.vue?vue&type=template&id=75cbacc8&scoped=true&lang=pug&"
import script from "./FaqSearchPager.vue?vue&type=script&setup=true&lang=js&"
export * from "./FaqSearchPager.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FaqSearchPager.scss?vue&type=style&index=0&id=75cbacc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cbacc8",
  null
  
)

export default component.exports